(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amae-bundle-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.amae-bundle-v2__options').forEach(function (wrap) {
    var options = wrap.querySelectorAll('.amae-bundle-v2__option');
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) {
          o.classList.remove('amae-bundle-v2__option--selected');
          o.querySelector('.amae-bundle-v2__radio').classList.remove('amae-bundle-v2__radio--selected');
        });
        opt.classList.add('amae-bundle-v2__option--selected');
        opt.querySelector('.amae-bundle-v2__radio').classList.add('amae-bundle-v2__radio--selected');
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
